// extracted by mini-css-extract-plugin
module.exports = {"select-reason":"_9bplNYKz_i675zVI6RSwF","amount-reason":"_2tzwPMy7Uu8c5iRRg5ObxB","reason-for-refund":"_1KQuu0UtFn3CarDgJ2KoIM","reason-field":"_1BtEN-nNNjrROOw3B222Xp"};